import type { CategoryScoreRec } from '@typings/api/categoryRec';

export const STOREFRONT_CENTER_IMPRESSION_TYPE =
	'Rec Module: Storefront - Center';
export const MCVRM_SOURCE_CONTENT = 'recommended vendors mcvrm';

export interface CategoryRecommendationsContextType {
	categories: CategoryScoreRec[];
	selectedCategoryCode: Category.CategoryCode | null;
	vendorsByCategory: Record<string, Vendor.Raw[]>;
	isLoading: boolean;
	error: string | null;
	onSelectCategory: (code: string) => void;
	shouldShowNoResults: boolean;
	selectedCategoryVendors: Vendor.Raw[];
}

export interface CategoryRecommendationsProviderProps {
	vendorId: string | null;
	memberId: string | null;
	anonymousId: string;
	excludeCategoryCode?: Category.CategoryCode;
	marketCode: string | null;
	children: React.ReactNode;
}
